"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { useSession } from "@/hooks/use-session";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";
import posthog from "posthog-js";

export function LandingCta() {
  const t = useTranslations("landing");
  const { isAuthenticated } = useSession();
  const ctaHref = isAuthenticated ? "/new" : "/sign-up";
  const ref = useScrollReveal<HTMLElement>({ animation: "scale-in" });

  return (
    <section className="py-24" ref={ref}>
      <div className="mx-auto max-w-7xl px-6">
        <div className="relative overflow-hidden rounded-3xl border border-landing-border bg-landing-card p-12 text-center sm:p-16">
          {/* Glow */}
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_60%_at_50%_50%,rgba(52,211,153,0.06)_0%,transparent_100%)]" />

          <div className="relative">
            <h2 className="text-3xl font-bold tracking-tight text-ink sm:text-4xl">
              {t("cta.heading1")}
              <br />
              <span className="font-serif italic tracking-wide text-mint">
                {t("cta.heading2")}
              </span>
            </h2>
            <p className="mt-4 text-landing-muted">
              {t("cta.subtitle")}
            </p>
            <Link
              href={ctaHref}
              onClick={() => {
                posthog.capture("landing_click", { element: "cta_bottom" });
                if (!isAuthenticated) posthog.capture("sign_in_clicked", { source: "cta" });
              }}
              className="animate-glow-pulse mt-8 inline-flex rounded-full bg-mint px-10 py-4 text-base font-semibold text-[#052e25] transition-colors hover:bg-mint-dark"
            >
              {t("cta.button")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
